<template>
  <email-form-modal
    :modal-id="modalId"
    title="Email Work Order Profitability Report"
    help-text="Enter one or more emails to send the report to"
    :initial-emails="email ? [email] : null"
    :request="submitRequest"
  />
</template>

<script>
import EmailFormModal from '@/components/shared/EmailFormModal.vue';

export default {
  name: 'WorkOrdersProfitabilityEmailModal',
  components: {
    EmailFormModal,
  },
  props: {
    params: Object,
    email: String,
  },
  data() {
    return {
      modalId: 'work-order-profitability-email-modal',
    };
  },
  methods: {
    submitRequest(payload) {
      return this.$analyticsAPI.emailProfitabilityReport(payload.emails, this.params);
    },
  },
};
</script>
